module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="modal-error">\n	<div class="modal-error-container">\n		<a class="modal-error-close js-close">\n			<i class="ion-android-close"></i>\n		</a>\n		<div class="modal-error-inner">\n			<header class="modal-error-header">Matchups</header>\n			<div class="modal-error-body">\n				<p>Matchups will become available after the completion of the league\'s start round!</p>\n				<div class="modal-error-btn">\n					<button class="btn js-close">Yep, got it!</button>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>';
}
return __p;
};
